exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".padding-add{padding-left:15px;padding-right:15px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/main/panels/addToAccount/styles.less
 ** module id = 606
 ** module chunks = 0
 **/